import RegionManager from '../components/admin/RegionManager'

export default function RegionManagerPage() {
  return <RegionManager />
}
